'use client';

import React, { FC } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { isPresent } from '@farmai-shared/LFUtils';
import { useActiveCrop, useActiveDistrict, useActiveLabel, useActiveProvince, useActiveSubdistrict, useActiveVillage } from './hooks';
type Row = readonly [label: string, value: string | null | undefined];
const PrintRow: FC<{
  row: Row;
}> = observer(({
  row: [label, value]
}) => <div className="mb-4 flex w-full gap-x-4">
    <p className="font-thin text-grey">{label}:</p>
    <p>{value ?? '-'}</p>
  </div>);
export const PrintFilterDropdowns: FC<{
  timePeriod: string;
}> = observer(({
  timePeriod
}) => {
  const {
    t
  } = useTranslation();
  const {
    activeCropLabel
  } = useActiveCrop();
  const {
    labels
  } = useActiveLabel();
  const {
    activeProvinceLabel
  } = useActiveProvince();
  const {
    activeDistrictLabel
  } = useActiveDistrict();
  const {
    activeSubdistrictLabel
  } = useActiveSubdistrict();
  const {
    activeVillageLabel
  } = useActiveVillage();
  const labelDisplay = isPresent(labels) ? labels.map(option => option.label).join(', ') : '-';
  const leftColumn = [[t('province'), activeProvinceLabel], [t('district'), activeDistrictLabel], [t('subdistrict'), activeSubdistrictLabel], [t('village'), activeVillageLabel]] satisfies ReadonlyArray<Row>;
  const rightColumn = [[t('crop'), activeCropLabel || '-'], [t('season'), timePeriod], [t('labels'), labelDisplay]] satisfies ReadonlyArray<Row>;
  return <div className={`
          m-auto hidden w-full flex-col items-center justify-center gap-x-4 px-24
          print:flex
        `}>
        <hr className="mt-8 mb-4 h-px w-full border-silver bg-gray-300" />

        <div className={`
          w-full px-12 py-5
          print:grid print:grid-cols-2 print:gap-x-12 print:gap-y-2
        `}>
          <div className="flex flex-col">
            {leftColumn.map(([label, value]) => <PrintRow key={label} row={[label, value ?? '-']} />)}
          </div>

          <div className="flex flex-col">
            {rightColumn.map(([label, value]) => <PrintRow key={label} row={[label, value ?? '-']} />)}
          </div>
        </div>

        <hr className="my-4 h-px w-full border-silver bg-gray-300" />
      </div>;
});